import React, { useEffect } from "react";
import Navbar from "./global-components/navbar";
import Footer from "./global-components/footer";
import { logEvent, trackMetaEvent } from "../analytics/analytics";

const YouthAmbassador = () => {
  let publicUrl = process.env.PUBLIC_URL + "/";
  const formUrl = "https://forms.gle/rCC3mApZghytQ93R9";

  useEffect(() => {
    logEvent("view_youth_ambassador_page", {
      category: "Youth Ambassador",
      label: "/youth-ambassador-program",
    });

    trackMetaEvent("ViewContent", {
      content_name: "Youth Ambassador Program",
      content_category: "Campaign Page",
      content_path: "/youth-ambassador-program",
    });
  }, []);

  return (
    <div style={{ overflowX: "hidden" }}>
      <Navbar />
      {/* Banner Section - Full Width */}
      <div className="ltn__img-slider-area mb-0" style={{ overflowX: "hidden" }}>
        <div className="container-fluid p-0">
          <div className="row g-0">
            <div className="col-12">
              <div
                className="youth-ambassador-banner"
                style={{
                  width: "100%",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={publicUrl + "assets/img/img-slide/youth-ambassador-banner.webp"}
                  alt="Atom Power Youth Ambassador - Empowering the Next Generation of Leaders"
                  className="img-fluid"
                  style={{
                    width: "100%",
                    height: "auto",
                    display: "block",
                    objectFit: "cover",
                    objectPosition: "center top",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="ltn__about-us-area pt-120 pb-90 section-bg-1">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 col-xl-8 mx-auto px-3 px-md-4">
              <h1 className="mb-3">Atom Power Youth Ambassador 2026</h1>
              <h3 className="mb-4 text-dark">The Elite 90-Day Sprint</h3>

              <p className="mb-4">
                The Atom Power Youth Ambassador Program (APYAP) 2026 is a
                high-intensity, <strong>3-month sprint</strong> that empowers
                top-tier students to become the face of renewable energy. It
                runs on a 90-day recruitment cycle where ambassadors execute
                Impact Missions for Atom Power&apos;s solar and EV initiatives.
              </p>

              <p className="mb-4">
                As a frontline champion, you will spend 12 weeks building
                awareness for the future of clean energy. You will mobilize your
                networks and ensure Atom Power&apos;s visibility on digital and
                physical platforms.
              </p>

              <p className="mb-5">
                This is a{" "}
                <strong>fast-paced leadership track</strong>. We are looking for
                the <strong>visionary</strong>,{" "}
                <strong>tech-savvy students</strong> who don&apos;t just want to
                watch the future happen, they want to{" "}
                <strong>power it</strong>.
              </p>

              <h4 className="mb-4">Ideal Candidates Are:</h4>

              <ul className="mb-5">
                <li className="mb-4">
                  <strong>Eligibility Criteria:</strong> Open to all academic students (Intermediate level &amp; above) from any discipline, as well as working professionals who can dedicate a few hours to contribute with us while managing their academic or professional commitments effectively.
                </li>
                <li className="mb-4">
                  <strong>Communication Powerhouses:</strong> Exceptional storytellers with the ability to simplify complex energy tech into compelling, influential conversations.
                </li>
                <li className="mb-4">
                  <strong>Campus Leaders:</strong> Active contributors in student societies, engineering clubs, or environmental initiatives with a proven ability to mobilize peers.
                </li>
                <li className="mb-4">
                  <strong>Digital Natives (Plus Point):</strong> Content creators with a strong, professional presence on LinkedIn, Instagram, and TikTok, ready to showcase the #PoweringChange movement.
                </li>
                <li className="mb-4">
                  <strong>Growth Mindset:</strong> Students eager to &quot;Level
                  Up&quot; through a gamified tier system, gaining real-world
                  experience in the renewable energy sector in record time.
                </li>
                <li className="mb-4">
                  <strong>Networkers:</strong> Confident collaborators capable of
                  working with student bodies, faculty, and event organizers to host
                  high-impact workshops and demos.
                </li>
                <li className="mb-4">
                  <strong>Mission-Driven:</strong> Deeply passionate about Atom
                  Power&apos;s goal to electrify the world sustainably and ready
                  to represent that mission with pride.
                </li>
              </ul>

              <h4 className="mb-4">The 90-Day Sprint Breakdown:</h4>

              <ol className="mb-5" style={{ paddingLeft: "1.25rem" }}>
                <li className="mb-4">
                  <strong>Month 1 (Onboarding &amp; Activation):</strong> Complete
                  your 1-day hybrid training, activate your referral code, and
                  launch your first community outreach mission.
                </li>
                <li className="mb-4">
                  <strong>Month 2 (Momentum &amp; Tier Climb):</strong> Execute
                  weekly missions, drive energy consultations, and move from{" "}
                  <strong>Explorer</strong> to <strong>Champion</strong> status.
                </li>
                <li className="mb-4">
                  <strong>Month 3 (Elite Status &amp; Legacy):</strong> Finalize
                  your impact goals, unlock your{" "}
                  <strong>Elite Fellow</strong> status, and secure your
                  professional certifications and recommendation letters &amp;
                  stipends if applicable.
                </li>
              </ol>

              <h4 className="mb-4">Program Details:</h4>

              <ul className="mb-5">
                <li className="mb-3">
                  <strong>Duration:</strong> 3-Month Intensive Sprint (Cohort 1)
                </li>
                <li className="mb-3">
                  <strong>Benefits:</strong> Monthly Support Allowance (Stipends
                  for Champions), Digital Prestige Badges, Paid Internship
                  Opportunities, and Priority Hiring.
                </li>
                <li className="mb-3">
                  <strong>Location:</strong> Nationwide Hybrid Program
                </li>
              </ul>

              <p className="mb-5">
                Ready to lead the revolution? Join the Atom Youth Ambassador
                Program and power the change today.
              </p>

              <a
                href={formUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="theme-btn-1 btn btn-effect-1 text-uppercase"
                style={{
                  padding: "14px 28px",
                  fontSize: "1rem",
                  fontWeight: 600,
                }}
              >
                Join Now <i className="fas fa-arrow-right ms-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default YouthAmbassador;
